(() => {
  class EmberCategoryGrid extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = [...this.querySelectorAll('[data-product-category]')];
      this.buttons = [...this.querySelectorAll('[data-category]')];
      this.querySelector('[data-category-controls]').hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-category]');
        if (!button) return;
        history.replaceState(null, '', `${location.pathname}${location.search}#${button.dataset.category}`);
        this.filter();
      });
      this.addEventListener('change', () => this.filter());
      this.onHashChange = () => this.filter();
      window.addEventListener('hashchange', this.onHashChange);
      this.filter();
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.onHashChange); }
    filter() {
      const requested = location.hash.slice(1);
      const category = this.buttons.some((button) => button.dataset.category === requested) ? requested : 'all';
      const inStock = this.querySelector('[data-in-stock]').checked;
      const sort = this.querySelector('[data-category-sort]').value;
      const sorted = [...this.cards].sort((a, b) => {
        if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true') || Number(a.dataset.position) - Number(b.dataset.position);
      });
      const grid = this.querySelector('[data-category-products]');
      let count = 0;
      sorted.forEach((card) => {
        card.hidden = !((category === 'all' || card.dataset.productCategory === category) && (!inStock || card.dataset.available === 'true'));
        if (!card.hidden) count++;
        grid.appendChild(card);
      });
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      const label = this.buttons.find((button) => button.dataset.category === category).textContent.trim();
      this.querySelector('[data-category-count]').textContent = `${count} ${count === 1 ? 'product' : 'products'}${category === 'all' ? '' : ` in ${label}`}${inStock ? ' in stock' : ''}`;
      this.querySelector('[data-category-empty]').hidden = count > 0;
    }
  }
  if (!customElements.get('ember-category-grid')) customElements.define('ember-category-grid', EmberCategoryGrid);
})();
